module.exports = __webpack_public_path__ + "967cfc98c7203907dfe53ee5fd42977c.woff";